<script>
import ProductCard from '@phoenix/mixins/components/product/ProductCard';
import WishlistButton from '../wishlist/WishlistButton';
import { PhxIcon } from '@phx-styleguides/jlc';

export default {
  components: {
    WishlistButton,
    PhxIcon,
  },

  mixins: [ProductCard],

  props: {
    reference: {
      type: String,
      required: true,
    },
    sapReference: {
      type: String,
      required: true,
    },
    large: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    classes() {
      return [
        'product-card',
        {
          'product-card--large': this.large,
          'product-card--horizontal': this.horizontal,
        },
      ];
    },
  },
};
</script>

<template>
  <div :class="classes" :data-cy-reference="reference">
    <div class="product-card__picture">
      <div class="picture">
        <picture-lazy v-bind="image" img-class="product__img" />
      </div>
    </div>

    <div class="product-card__body">
      <a :href="url" :target="openLinkInNewWindow ? '_blank' : '_self'" class="product-card__link expand-target">
        <div class="product-card__details">
          <h5 class="product-card__collection">{{ collection }}</h5>
          <h5 class="product-card__name">{{ name }}</h5>

          <div class="product-card__specs" data-cy="product-card-reference">
            {{ $t('Product.reference', { reference: sapReference }) }}
            <slot name="size"></slot>
          </div>
          <div class="product-price product-price--small mt-sm">
            <span class="product-price__value">
              <slot name="price"></slot>
            </span>
            <span class="product-price__vat">{{ vatInformation }}</span>
          </div>

          <div
            v-for="error in errors"
            :key="`error_${id}_${error}`"
            class="alert alert--badge product-card__out-of-stock"
            data-cy="no-stock-alert-item"
          >
            <div class="alert__icon">
              <phx-icon icon="info-16" />
            </div>
            {{ $t(`Checkout.product.${error}.tag`) }}
          </div>
        </div>
      </a>

      <div class="product-card__actions">
        <slot name="product-card-actions">
          <wishlist-button v-if="shouldDisplayAddToWishlist" :reference="reference" :name="name" icon="cross-16" />

          <button
            v-if="shouldDisplayRemoveFromCart"
            type="button"
            class="btn btn--default btn--xs btn--icon-only btn--icon btn--transparent"
            :data-cy="dataCyRemoveButton"
            :title="$t('Checkout.removeProduct', { product: name })"
            @click.stop="onRemove({ id, tracking })"
          >
            <span class="btn__icon pointer-events-none">
              <phx-icon icon="cross-16" />
            </span>
          </button>
        </slot>
      </div>
    </div>
  </div>
</template>
